import autoImporter from '@modules/auto-importer';

const requireDirective = require.context(
  './',
  true,
  /^(?!.*index\.js$).*[a-zA-Z]\w+\.(js|ts|scss)/
);

export const directives = autoImporter(requireDirective);
